import React, { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../store/hooks';
import ProtectedRoute from '../components/common/ProtectedRoute';
import LoginForm from '../modules/auth/LoginForm';
import MainLayout from '../components/layout/MainLayout';

// Module imports
import Dashboard from '../modules/dashboard/index';
import Users from '../modules/usersManagement/index';
import rules from '../modules/ruleManagement/index';
import Approval from '../modules/approvalManagement/index';
import Spares from '../modules/spares/index'
import Settings from '../modules/settings/Settings';
import ProcessOrder from '../modules/plant/index';

// Helper
import { createRoutesFromModules } from './routeConfig';
import plantCreate from '../modules/plant/form/create/plantCreate';
import plantEdit from '../modules/plant/form/edit/plantEdit';
import ruleForm from '../modules/ruleManagement/form/RuleFormModal';
import ApprovelForm from '../modules/approvalManagement/AssignUserForm';
// 🔹 Map module names to components (easy to extend)
const MODULE_COMPONENTS: Record<string, React.FC> = {
  DASHBOARD: Dashboard,
  USER_MANAGEMENT: Users,
  RULE_MANAGEMENT: rules,
  APPROVER_MANAGEMENT: Approval,
  SPARES: Spares,
  SETTINGS: Settings,
  PLANT: ProcessOrder,
  PLANT_CREATE: plantCreate,
  PLNT_EDIT: plantEdit,
  RULE_CREATE: ruleForm,
  APPROVER_CREATE: ApprovelForm,

};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const modulesData = useSelector((state: any) => state.auth.moduleDetails?.moduleDetails || []);

  //  Memoize route creation to avoid recomputation
  const dynamicRoutes = useMemo(
    () => createRoutesFromModules(modulesData),
    [modulesData]
  );
  // console.log(dynamicRoutes, 'dynamicRoutes', modulesData);


  // 🔐 Non-authenticated routes
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <MainLayout>
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/user" replace />} />

    

        {/* Dynamically generated module routes */}
        {dynamicRoutes.map(({ path, component }) => {
          const Component = MODULE_COMPONENTS[component];
          if (!Component) return null; // Skip if component not mapped

          return (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute>
                  <Component />
                </ProtectedRoute>
              }
            />
          );
        })}

        {/* Fallback route */}
        {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
      </Routes>
    </MainLayout>
  );
};

export default AppRoutes;

